// extracted by mini-css-extract-plugin
module.exports = {"container":"PrimaryHeading_container__14jkG","heading":"PrimaryHeading_heading__33yn-","sending":"PrimaryHeading_sending__2ybsd"};